import {
  HomepageFeatureCard,
  HomepageInterest,
  HomepagePlatformSection,
  PietraAgenticCard,
  PlatformDisplayItemType,
  SectionTabType,
} from '../types/homepage';

import { STATIC_FILE_URL } from '@/shared/constants';

export const SECTION_TABS: SectionTabType[] = [
  {
    activeBgColor: '#ff5c3c',
    activeTextColor: '#fff',
    anchor: '#sourcing',
    key: 'sourcing',
    text: 'Suppliers & Packaging',
  },
  {
    activeBgColor: '#f9e070',
    activeTextColor: '#000',
    anchor: '#order-fulfillment',
    key: 'order-fulfillment',
    text: 'Logistics & Fulfillment',
  },
  {
    activeBgColor: '#57ad6a',
    activeTextColor: '#fff',
    anchor: '#sales-tools',
    key: 'sales-tools',
    text: 'Sales & Marketing Tools',
  },
];

export const PLATFORM_DISPLAY_ITEMS: PlatformDisplayItemType[] = [
  {
    key: HomepageInterest.DESIGN,
    buttonText: 'Design',
    image: '/svg/nav-icon-design.svg',
    path: '/platform/design-studio',
    desc: 'Use AI to create mood boards and ideate.',
  },
  {
    key: HomepageInterest.SOURCING,
    buttonText: 'Sourcing',
    image: '/svg/nav-icon-sourcing.svg',
    path: '/platform/sourcing-and-production',
    desc: 'Sourcing products & packaging at low costs.',
  },
  {
    key: HomepageInterest.LOGISTICS,
    buttonText: 'Logistics',
    image: '/svg/nav-icon-logistics.svg',
    path: '/platform/logistics-and-fulfillment',
    desc: 'Saving thousands on order fulfillment.',
  },
  {
    key: HomepageInterest.STOREFRONT,
    buttonText: 'Storefront',
    image: '/svg/nav-icon-storefront.svg',
    path: 'https://creator.pietrastudio.com/homebase?tab=STOREFRONT',
    desc: 'No fuss storefronts to start selling fast.',
  },
  {
    key: HomepageInterest.MARKETING,
    buttonText: 'Marketing',
    image: '/svg/nav-icon-marketing.svg',
    path: '/platform/sales-and-marketing',
    desc: 'Popular software at steep discounts.',
  },
  {
    key: HomepageInterest.ANALYTICS,
    buttonText: 'Analytics',
    image: '/svg/nav-icon-analytics.svg',
    path: '/platform/analytics',
    desc: 'Get data to grow your sales faster.',
  },
];

export const HOMEPAGE_TAB_SECTIONS: HomepagePlatformSection[] = [
  {
    id: 'sourcing',
    isTextLeft: true,
    image: `${STATIC_FILE_URL}/7c08e14c54d21c3e397e777187184ab8.png`,
    preTitle: {
      text: 'Suppliers & Packaging',
      color: '#FF5C3C',
    },
    title: {
      text: 'Use AI to find and negotiate with suppliers & vendors.',
      color: '#000',
    },
    description: {
      text: 'Get direct access to 40,000+ suppliers with Pietra.',
      color: 'rgba(0, 0, 0, 0.6)',
    },
    buttons: [
      {
        text: 'Learn more',
        color: '#fff',
        bgColor: '#FF5C3C',
        path: '/platform/sourcing-and-production/products',
      },
    ],
    withPietraComparator: {
      titleGradient: 'linear-gradient(95deg, #FF5C3C 45.89%, #F5BE32 118.46%)',
      borderColor: '#FF5C3C',
      backgroundColor: '#F9F2F1',
      withBullets: [
        'AI finds factories to match your needs',
        'Browse factories and reach out',
        'Sourcing experts available to assist',
        'Low minimums & quick lead times',
      ],
      withoutBullets: ['Messy email management', 'Hire brokers or consultants', 'High minimums required'],
    },
  },
  {
    id: 'order-fulfillment',
    isTextLeft: true,
    image: `${STATIC_FILE_URL}/1c4fef3e00d18342a6fd6cd806791f6e.png`,
    preTitle: {
      text: 'Logistics & Fulfillment',
      color: '#f9e070',
    },
    title: {
      text: 'Fulfillment infrastructure that scales with your business.',
      color: '#000',
    },
    description: {
      text: 'Pietra members save 40-50% on storage, fulfillment, and shipping.',
      color: 'rgba(0, 0, 0, 0.6)',
    },
    buttons: [
      {
        text: 'Learn more',
        color: '#000',
        bgColor: '#f9e070',
        path: '/platform/logistics-and-fulfillment',
      },
    ],
    withPietraComparator: {
      titleGradient: 'linear-gradient(95deg, #D09808 45.89%, #64F30D 118.46%)',
      borderColor: '#C5A827',
      backgroundColor: '#FFFBE7',
      withBullets: ['No minimums, no set up fees', '$1.15/order unlimited picks', 'Human account manager & CX'],
      withoutBullets: ['Setup fees of $500+', '$2.50+/order fees', 'Automated customer support'],
    },
    testimonial: {
      author: {
        brand: 'Bad Mouth, Organic Candy Brand',
        name: 'Kasey Stewart',
      },
      bgColor: '#f9e070',
      image: 'https://static.pietrastudio.com/public/file_uploads/becae2f023bc78fda01d27c7b20c27b0.png',
      isTextLeft: false,
      review: {
        color: '#58502B',
        text: 'Pietra has saved us time & money by partnering with the right suppliers. Their fulfillment center has also been incredible to work with in regards to customer service, low incidents, and shipping speed.',
      },
      title: {
        color: '#000',
        text: 'Bad Mouth reduced their fulfillment incidents by 10% with Pietra.',
      },
    },
  },
  {
    id: 'sales-tools',
    isTextLeft: true,
    image: `${STATIC_FILE_URL}/5292cdf392e1449f14717fc10462248b.png`,
    preTitle: {
      text: 'Sales & Marketing Tools',
      color: '#57AD6A',
    },
    title: {
      text: 'Marketing intelligence and content creation powered by AI.',
      color: '#000',
    },
    description: {
      text: 'Remove hours of busy work with social listening, trend forecasting, paid marketing reporting, and more.',
      color: 'rgba(0, 0, 0, 0.6)',
    },
    buttons: [
      {
        text: 'Learn more',
        color: '#fff',
        bgColor: '#57AD6A',
        path: '/platform/sales-and-marketing',
      },
    ],
    withPietraComparator: {
      titleGradient: 'linear-gradient(95deg, #4AB409 45.89%, #09B0B0 118.46%)',
      borderColor: '#57AD6A',
      backgroundColor: '#EBF5ED',
      withBullets: ['Find influencers', 'Monitor social media', 'Create marketing content'],
      withoutBullets: ['Agency and retainer fees', 'Lock in contracts'],
    },
    testimonial: {
      author: {
        brand: 'Gel Blasters',
        name: 'Oren Schauble',
      },
      bgColor: '#57AD6A',
      image: 'https://static.pietrastudio.com/public/file_uploads/782980d8f3bad5ff58f0dfd404be40d7.png',
      isTextLeft: false,
      review: {
        color: '#DBECDE',
        text: "I can't believe we were leaving that much money on the table. Pietra's audience capture tools are a gamechanger for anyone in commerce.",
      },
      title: {
        color: '#fff',
        text: 'Gel Blasters is an 8 figure brand leveraging Pietra to supercharge their marketing',
      },
    },
  },
];

export const FEATURE_CARDS: HomepageFeatureCard[] = [
  {
    title: 'Product design tools',
    desc: 'AI-powered creative tools to bring product & packaging ideas to life.',
    img: `${STATIC_FILE_URL}/445c9a2a3b3b794a92e5116b70a0d12f.png`,
    path: '/platform/design-studio',
    vimeoId: 905396529,
  },
  {
    title: 'Sourcing & Production',
    desc: 'Marketplace of vetted factories for products, packaging, and creative services.',
    img: `${STATIC_FILE_URL}/019bc765a9c56085701ccebba26b0542.png`,
    path: '/platform/sourcing-and-production',
    vimeoId: 905327233,
  },
  {
    title: 'Order fulfillment',
    desc: 'Infrastructure to store and ship products around the world from your website.',
    img: `${STATIC_FILE_URL}/9c112bdaf71d27b7b12cd05fd7911656.png`,
    path: '/platform/logistics-and-fulfillment',
    vimeoId: 905373249,
  },
  {
    title: 'E-commerce storefront',
    desc: 'Create a beautiful website in minutes to start selling fast.',
    img: `${STATIC_FILE_URL}/8ac96eb9e7b5d8e7df82b1892f724465.png`,
    path: '/platform/sales-and-marketing',
    vimeoId: 905460243,
  },
  {
    title: 'Website Visitor ID',
    desc: 'Build your email list from website visitors.',
    img: `${STATIC_FILE_URL}/a7eab2cc7e4575fc57f878d302b69211.png`,
    path: '/platform/email-capture',
    vimeoId: 906475808,
  },
  {
    title: 'Affiliate Marketing',
    desc: 'Set up and run an influencer marketing program.',
    img: `${STATIC_FILE_URL}/2cb0df5c50e9168bb3b35f21d399ac6f.png`,
    path: '/platform/affiliate-marketing',
    vimeoId: 906475808,
  },
  {
    title: 'Data & Dashboards',
    desc: '35+ business dashboards to understand your business.',
    img: `${STATIC_FILE_URL}/cc0628988f0c9b2a2d031affc45c62b0.png`,
    path: '/platform/analytics',
    vimeoId: 905759953,
  },
  {
    title: 'Print on demand',
    desc: 'Make merch and promotional products at heavily discounted rates.',
    img: `${STATIC_FILE_URL}/daaf49beeb9a4e1bc4107243ffe9cbfa.png`,
    path: '/platform/print-on-demand',
    vimeoId: 905737521,
  },
  {
    title: 'Business planning tools',
    desc: 'Get a step-by-step guide to building an online business. Great for beginners getting started.',
    img: `${STATIC_FILE_URL}/23ff97a90a53847d0668beb022d12ae9.png`,
    path: 'https://builder.pietrastudio.com',
    external: true,
    vimeoId: 906172756,
  },
  {
    title: 'Weekly workshops',
    desc: 'Get access to professionals each week to help you maximize Pietra.',
    img: `${STATIC_FILE_URL}/60fd924583a71e41216b6fa0d4e14529.png`,
    path: '/sell-on-pietra/register',
  },
];

export const HOMEPAGE_V4_INTRO_LOGOS = [
  {
    src: '/svg/rhode.png',
    alt: 'Rhode',
    width: 63,
    height: 16,
  },
  {
    src: '/svg/honest.png',
    alt: 'The Honest Company',
    width: 107,
    height: 16,
  },
  {
    src: '/svg/brooklinen.svg',
    alt: 'Brooklinen',
    width: 94,
    height: 16,
  },
  {
    src: '/svg/halfdays.svg',
    alt: 'Halfdays',
    width: 69,
    height: 16,
  },
  {
    src: '/svg/coterie.png',
    alt: 'Coterie',
    width: 75,
    height: 16,
  },
  {
    src: '/svg/atoms.svg',
    alt: 'Atoms',
    width: 89,
    height: 16,
  },
  {
    src: '/svg/canopy.svg',
    alt: 'Canopy',
    width: 55,
    height: 16,
  },
  {
    src: '/svg/lalo.png',
    alt: 'Lalo',
    width: 59,
    height: 16,
  },
  {
    src: '/svg/everlane_logo.svg',
    alt: 'Everlane',
    width: 109,
    height: 16,
  },
  {
    src: '/svg/gorgie.png',
    alt: 'Gorgie',
    width: 81,
    height: 16,
  },
  {
    src: '/svg/jack_archer.png',
    alt: 'Jack Archer',
    width: 152,
    height: 16,
  },
];

export const HOMEPAGE_PIETRA_OFFERINGS = [
  {
    title: 'Source with no fees',
    description: 'Find & work with factories.',
    icon: '/svg/shipment-international.svg',
  },
  {
    title: 'Order fulfillment',
    description: 'Lower costs by up to 40%.',
    icon: '/svg/order-fulfillment.svg',
  },
  {
    title: 'Track industry data',
    description: 'Monitor ads & content.',
    icon: '/svg/ai-search.svg',
  },
  {
    title: 'Hire influencers',
    description: 'Find content-specific creators.',
    icon: '/svg/advertising-megaphone.svg',
  },
  {
    title: 'Make content',
    description: 'Use AI to make marketing assets.',
    icon: '/svg/image-file-ai.svg',
  },
  {
    title: 'Finance a PO',
    description: 'Get special lending rates.',
    icon: '/svg/discount-dollar-dash.svg',
  },
  {
    title: 'Expand into retail',
    description: 'Contact retail buyers worldwide.',
    icon: '/svg/shop.svg',
  },
  {
    title: 'Build an email list',
    description: 'Get emails from website traffic.',
    icon: '/svg/shopping-voucher-mail.svg',
  },
  {
    title: 'Find new customers',
    description: 'Let AI find you new customers.',
    icon: '/svg/human-resources-rating-man.svg',
  },
];

export const AGENTIC_CARDS: PietraAgenticCard[] = [
  {
    icon: {
      url: 'https://static.pietrastudio.com/public/file_uploads/a4377904ddc97ebde8327a3878f0e6a9.svg',
      bgColor: 'radial-gradient(127.58% 127.5% at 25.04% 20.84%, #ECEBFF 0%, #EBE1FE 100%)',
    },
    agentName: 'Social & Market Research Agent',
    title: "Stay on top of your brand's daily news",
    description:
      "I'll track your brand's mentions, competitors, and market trends and deliver daily updates so you can act fast and stay ahead.",
    textColor: 'radial-gradient(127.58% 127.5% at 25.04% 20.84%, #535AFF 0%, #7D33F7 100%)',
  },
  {
    icon: {
      url: 'https://static.pietrastudio.com/public/file_uploads/51904d13540071f9b5072823d19f813b.svg',
      bgColor: 'linear-gradient(43deg, #F9DBDB 26.92%, #FDF1DF 77.91%)',
    },
    agentName: 'Influencer & Affiliate Agent',
    title: 'Spot influencer mentions the moment they happen',
    description:
      "I'll monitor social platforms and alert you when a creator posts about your brand so you never miss a chance to engage.",
    image: `${STATIC_FILE_URL}/d6f483458716d6058c88151dbd693619.png`,
    textColor: 'linear-gradient(43deg, #FF4A4A 26.92%, #E9AA4B 77.91%)',
  },
  {
    icon: {
      url: 'https://static.pietrastudio.com/public/file_uploads/578be5523186e2139a0941fe3ba6a3d3.svg',
      bgColor: 'radial-gradient(208.48% 182.32% at -0.04% -0.23%, #D9EFFF 0%, #DAE4FF 100%)',
    },
    agentName: 'Content Creation Agent',
    title: 'Grow your audience with on-brand social posts',
    description:
      "I'll create posts featuring your products and trending styles to keep your brand relevant, trusted, and top of mind.",
    image: `${STATIC_FILE_URL}/f4ebcb9a39e9500193843df7dfcd4995.png`,
    textColor: 'radial-gradient(208.48% 182.32% at -0.04% -0.23%, #41AFFF 0%, #4865FF 100%)',
  },
  {
    icon: {
      url: 'https://static.pietrastudio.com/public/file_uploads/eb4811114d5268e1ce5e5d0213e8e4bc.svg',
      bgColor: 'radial-gradient(213.37% 213.37% at 27.54% 0%, #E1F5DE 0%, #DBF5E3 100%)',
    },
    agentName: 'Sales & Storefront Agent',
    title: 'Turn website visitors into marketing opportunities',
    description:
      "I'll identify who's visiting your site and turn that data into ready-to-use audiences for ads, emails, and retargeting.",
    textColor: 'radial-gradient(213.37% 213.37% at 27.54% 0%, #71CE51 0%, #32CB8B 100%)',
  },
  {
    icon: {
      url: 'https://static.pietrastudio.com/public/file_uploads/10af9c6bb5d47c9b31f33f46ba5cc727.svg',
      bgColor: 'radial-gradient(127.58% 127.5% at 25.04% 20.84%, #F4DCF9 0%, #FCD7FC 100%)',
    },
    agentName: 'Task Automation Agent',
    title: 'Automate your daily tasks and reports',
    description:
      "From data analysis to performance summaries, I'll handle your routine work so you can focus on what matters most.",
    textColor: 'radial-gradient(127.58% 127.5% at 25.04% 20.84%, #C853FF 0%, #F733EF 100%)',
  },
];
